module.exports = __webpack_public_path__ + "img/toggle-rules.41d1efab.svg";